import React, { useEffect, useRef } from 'react';
import ExperimentKitCard from './ExperimentKitCard';

const PricingSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.animate-on-scroll');
          elements.forEach((el, i) => {
            setTimeout(() => {
              el.classList.add('visible');
            }, i * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return <section ref={sectionRef} id="pricing" className="section-padding bg-white">
      <div className="container">
        {/* Experiment Kit Section */}
        <div className="mb-16">
          <div className="text-center max-w-3xl mx-auto mb-10 animate-on-scroll">
            <h3 className="text-2xl font-bold mb-2">
              Try Your Own Experiment Kit
            </h3>
            <p className="text-neutral-700">Get your co-branded experiment kits to self-test your product or engage your team and creators.</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <ExperimentKitCard />
          </div>
        </div>
      </div>
    </section>;
};
export default PricingSection;